export type DeclineSurveyResponse = {
    reasonId: string;
    comment?: string;
};

export type DeclineSurveyReason = {
    id: string;
    description: string;
};

export type StatefulReason = DeclineSurveyReason & {
    checked: boolean;
};

export enum Status {
    Complete = 'COMPLETE',
    Error = 'ERROR',
    Fetching = 'FETCHING',
    Submitting = 'SUBMITTING',
    Ready = 'READY',
}
